import { render } from "./XIconSolidUserCircleMinus.vue?vue&type=template&id=4084ad67"
import script from "./XIconSolidUserCircleMinus.vue?vue&type=script&lang=js"
export * from "./XIconSolidUserCircleMinus.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidUserCircleMinus.vue"]])

export default __exports__